module.exports = __webpack_public_path__ + "img/banner05_info1.86482104.svg";